<template>
  <div class="svg-wrapper">
    <div
      v-html="standardize(toEditVal)"
      class="svg-image"
    />
    <div
      v-if="disabled || readOnly"
      class="svg-label"
    >
      {{ label }}
    </div>
    <v-textarea
      v-if="!disabled && !readOnly"
      v-bind="field"
      v-model="toEditVal"
      :label="label"
      :rules="rules"
      :disabled="disabled || readOnly"
      :rows="numRows"
      @change="$emit('update:toEdit', toEditVal)"
      hint="Pas aan op eigen risico. #color is de kleur van de materiaal status of toepassing, #opacity de transparantheid."
      persistent-hint
    />
  </div>
</template>

<script>

export default {
  name: 'SvgField',
  props: {
    field: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    rules: {
      type: Array,
      default: () => []
    },
    // eslint-disable-next-line vue/require-prop-types
    toEdit: {
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      toEditVal: this.toEdit
    }
  },
  computed: {
    numRows () {
      const value = this.toEditVal
      if (!value || value.length < 200) { return 5 }
      return Math.ceil(value.length / 100) + 4
    }
  },
  watch: {
    toEdit () {
      this.toEditVal = this.toEdit
    }
  },
  methods: {
    standardize(value) {
      if (!value) { return '' }
      // Set standard color if a color is a variable
      value = value.replace('"#color"', '"black"')
      // Set a standard width so it fits neatly on the webpage
      value = value.replace(/width="\d+(px)*"/, 'width="5em"')
      value = value.replace(/height="\d+(px)*"/, 'height="5em"')
      return value
    }
  }
}
</script>

<style lang="scss" scoped>
  .svg-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.5em;

    .svg-image {
      height: 5em;
      width: 5em;
      margin-right: 1em;
    }

    .svg-label {
      color: rgba(0, 0, 0, 0.38);
    }

    .v-input {
      max-width: calc(100% - 5em);
      margin-bottom: 1.5em;
    }
  }
</style>
